const KEYS = [
  "AIzaSyBu33AChZxQMJUoWwn0JGBhbK2arc190Mk",
  "AIzaSyCJTXZBa-PJDCbGyd_jmf0zvUGp4o9XiRI",
  "AIzaSyBDHvM-A0K1bBp7rCxR4rewLcX20_nmPIA",
  "AIzaSyDf0wMM0sqXycc6BEFstd6bvm-fyIZmPyg",
  "AIzaSyAGfKqSJU4BcMpielchF58zrAUr56cpn-c",
  "AIzaSyA7uEHIduOSgUbACGSd5APZO3F4KkUQo2Q",
  "AIzaSyBsGAjJDUnxqsJh7jxF09diCAkF5lS2x_s",
  "AIzaSyAPLUh4Kn8si8WbmvkVoMHArc7XQTJ0Mcc",
  "AIzaSyAwc3jebZVgzC0kSUgM5zZD0AXDvOpV3sg",
  "AIzaSyBEw3mi6dLz22sagt5QI4wdq8oVTxTmokg",
  "AIzaSyAQimKsx6we-9Xg2V4VCGvwccstTGOXbf8",
  "AIzaSyDunLRomGvRYJyRhiNoj7saPwU7oEW8TOc",
  "AIzaSyDYUmz8SyLwlqUKuAS18aRwN_ekJCuRxts",
  "AIzaSyA5LP4t8E3bs7PLOZQoiByl1DXlf10G7dQ",
  "AIzaSyCEjWLMX8SbPXSabXjzfk6nbXj9bmvj6eQ",
];

const QUOTA_KEY = "yt_quota_exhausted";

function getExhaustedKeys() {
  try {
    const data = JSON.parse(localStorage.getItem(QUOTA_KEY) || "{}");
    const now = Date.now();
    const valid = {};
    for (const [key, time] of Object.entries(data)) {
      if (now - time < 86400000) valid[key] = time;
    }
    return valid;
  } catch { return {}; }
}

function markExhausted(key) {
  try {
    const data = getExhaustedKeys();
    data[key] = Date.now();
    localStorage.setItem(QUOTA_KEY, JSON.stringify(data));
  } catch {}
}

export function getAvailableKeys() {
  const exhausted = getExhaustedKeys();
  const available = KEYS.filter(k => !exhausted[k]);
  if (available.length === 0) {
    localStorage.removeItem(QUOTA_KEY);
    return KEYS;
  }
  return available;
}

export async function ytSearch(queryStr, maxResults = 5) {
  const keys = getAvailableKeys();
  for (const key of keys) {
    try {
      const r = await fetch(
        `https://www.googleapis.com/youtube/v3/search?part=snippet&q=${encodeURIComponent(queryStr)}&key=${key}&maxResults=${maxResults}&type=video`
      );
      const d = await r.json();
      if (d.error) {
        if (d.error.code === 403 || d.error.message?.includes("quota")) {
          markExhausted(key);
          continue;
        }
        continue;
      }
      if (d.items?.length > 0) return d.items;
    } catch { continue; }
  }
  return [];
}

export async function getItunesPreview(trackName, artistName) {
  try {
    const r = await fetch(
      `https://itunes.apple.com/search?term=${encodeURIComponent(`${trackName} ${artistName}`)}&media=music&limit=1`
    );
    const d = await r.json();
    const track = d.results?.[0];
    if (track?.previewUrl) return track.previewUrl;
  } catch {}
  return null;
}
export async function ytSearchMusic(queryStr, maxResults = 15) {
  const keys = getAvailableKeys();
  for (const key of keys) {
    try {
      const r = await fetch(
        `https://www.googleapis.com/youtube/v3/search?part=snippet&q=${encodeURIComponent(queryStr)}&key=${key}&maxResults=${maxResults}&type=video&videoCategoryId=10`
      );
      const d = await r.json();
      if (d.error) {
        if (d.error.code === 403 || d.error.message?.includes("quota")) {
          markExhausted(key);
          continue;
        }
        continue;
      }
      if (d.items?.length > 0) {
        // Filter out non-music content by title keywords
        const blockedWords = ["vlog", "reaction", "review", "tutorial", "how to", "interview", "behind the scenes", "trailer", "gameplay", "unboxing", "challenge"];
        const filtered = d.items.filter(item => {
          const title = item.snippet?.title?.toLowerCase() || "";
          return !blockedWords.some(w => title.includes(w));
        });
        return filtered.map(item => ({
          trackId: item.id.videoId,
          trackName: item.snippet.title,
          artistName: item.snippet.channelTitle,
          artworkUrl100: item.snippet.thumbnails?.high?.url || item.snippet.thumbnails?.default?.url,
          collectionName: "YouTube",
          fromYoutube: true,
        }));
      }
    } catch { continue; }
  }
  return [];
}